// ✅ NEW standard React entry point
import React from 'react';
import { createRoot } from 'react-dom/client';
import NidouxApp from './NidouxApp';
import './index.css';
import './i18n'; 

// Polyfill for global
window.global = window;

// ADD THIS ENTIRE BLOCK HERE (before createRoot):
(() => {
  const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  
  // Prevent double-tap to zoom
  let lastTouchEnd = 0;
  document.addEventListener('touchend', (e) => {
    const now = Date.now();
    if (now - lastTouchEnd <= 300) {
      e.preventDefault();
    }
    lastTouchEnd = now;
  }, { passive: false });

  // Prevent pinch zoom (all devices)
  document.addEventListener('touchmove', (e) => {
    if (e.touches.length > 1) {
      e.preventDefault();
    }
  }, { passive: false });

  if (isiOS) {
    // Block pinch gestures on iOS
    ['gesturestart', 'gesturechange', 'gestureend'].forEach(type => {
      document.addEventListener(type, (e) => e.preventDefault(), { passive: false });
    });
  }
})();


const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <NidouxApp />
  </React.StrictMode>
);